(() => {
  const SELECTOR = '[data-nimo-nexus-vote]';

  function initVoteSection(section) {
    if (section.dataset.nimoVoteReady === 'true') return;
    section.dataset.nimoVoteReady = 'true';

    const slides = Array.from(section.querySelectorAll('[data-nimo-vote-slide]'));
    const dots = Array.from(section.querySelectorAll('[data-nimo-vote-dot]'));
    const previousButton = section.querySelector('[data-nimo-vote-prev]');
    const nextButton = section.querySelector('[data-nimo-vote-next]');
    const formMount = section.querySelector('[data-nimo-klaviyo-form]');
    const liveRegion = section.querySelector('[data-nimo-vote-live]');
    const shopifySyncForm = section.querySelector('.nimo-nexus-vote__shopify-sync-form');
    const shopifyEmail = section.querySelector('[data-nimo-shopify-email]');
    const klaviyoFormId = section.dataset.klaviyoFormId;
    const klaviyoCompanyId = section.dataset.klaviyoCompanyId;
    const klaviyoListId = section.dataset.klaviyoListId;
    const leadSource = section.dataset.leadSource || 'Nexus Vote';
    const successParameter = section.dataset.successParameter || 'nexus_vote_submitted';
    const requestedVoteKey = new URLSearchParams(window.location.search).get('vote')?.trim().toLowerCase();
    const requestedIndex = requestedVoteKey
      ? slides.findIndex((slide) => slide.dataset.campaignKey?.trim().toLowerCase() === requestedVoteKey)
      : -1;
    let activeIndex = 0;
    let boundForm = null;
    let campaignSelectionApplied = false;
    let hashAligned = false;
    let lastSubmission = {};
    let submissionHandled = false;

    if (!slides.length) return;

    function normalizeLabel(value) {
      return (value || '').trim().replace(/\s+/g, ' ').toLowerCase();
    }

    function getRadioLabel(radio) {
      const explicitLabel = radio.getAttribute('aria-label') || radio.value;
      if (explicitLabel) return explicitLabel;

      if (radio.id) {
        const linkedLabel = formMount?.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
        if (linkedLabel?.textContent) return linkedLabel.textContent;
      }

      return radio.closest('label')?.textContent || radio.parentElement?.textContent || '';
    }

    function findMatchingRadio(optionLabel) {
      const targetLabel = normalizeLabel(optionLabel);
      return Array.from(formMount?.querySelectorAll('input[type="radio"]') || []).find(
        (radio) => normalizeLabel(getRadioLabel(radio)) === targetLabel
      );
    }

    function replaceButtonText(button) {
      const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      let textNode = walker.nextNode();

      while (textNode) {
        if (normalizeLabel(textNode.nodeValue).includes('cast my vote')) {
          textNode.nodeValue = 'Vote & Unlock Early Bird Access';
          break;
        }
        textNode = walker.nextNode();
      }

      button.setAttribute('aria-label', 'Vote and unlock Early Bird Access');
    }

    function replaceText(root, from, to) {
      const target = normalizeLabel(from);
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let textNode = walker.nextNode();

      while (textNode) {
        if (normalizeLabel(textNode.nodeValue) === target) textNode.nodeValue = to;
        textNode = walker.nextNode();
      }
    }

    function updateFormCopy(form) {
      replaceText(form, 'Vote for Your Favorite Nimo Nexus', 'Help Shape the Next Nimo Nexus');
      replaceText(
        form,
        'Be the First to Know When It Launches',
        'Compare six concepts and choose the one that best fits your needs.'
      );
      replaceText(
        form,
        'Which Nimo Nexus are you most interested in?',
        'Which Nimo Nexus best fits your needs?'
      );
      replaceText(form, 'Nimo Nexus Flash 495H', 'Nimo Nexus Flash 395/495 Pro');

      Array.from(form.querySelectorAll('input[type="radio"]')).forEach((radio) => {
        if (normalizeLabel(radio.value) !== 'nimo nexus flash 495h') return;
        radio.value = 'Nimo Nexus Flash 395/495 Pro';
        radio.setAttribute('aria-label', 'Nimo Nexus Flash 395/495 Pro');
      });
    }

    function enhanceKlaviyoForm(form) {
      updateFormCopy(form);
      const submitButton = form.querySelector('button[type="submit"], button.klaviyo-form-button');
      if (!submitButton) return;

      replaceButtonText(submitButton);
    }

    function readSubmission(form = boundForm) {
      if (!form) return lastSubmission;

      const selectedRadio = form.querySelector('input[type="radio"]:checked');
      const useCase = form.querySelector('input[placeholder="Select an option..."]');
      const priceRange = form.querySelector('input[placeholder="Select a price range"]');
      lastSubmission = {
        email: form.querySelector('input[type="email"]')?.value.trim() || lastSubmission.email || '',
        productInterest: selectedRadio ? getRadioLabel(selectedRadio).trim() : lastSubmission.productInterest || '',
        useCase: useCase?.value.trim() || lastSubmission.useCase || '',
        priceRange: priceRange?.value.trim() || lastSubmission.priceRange || '',
      };
      return lastSubmission;
    }

    async function handleSuccessfulSubmission() {
      if (submissionHandled) return;
      submissionHandled = true;

      const submission = readSubmission();
      window.NimoLeadRouting?.markSuccessInUrl(successParameter, 'true', '#nexus-vote-success');

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'nimo_nexus_vote_lead',
        form_id: klaviyoFormId,
        product_interest: submission.productInterest,
      });

      if (submission.email && window.NimoLeadRouting) {
        window.NimoLeadRouting.subscribeToKlaviyoList({
          companyId: klaviyoCompanyId,
          listId: klaviyoListId,
          email: submission.email,
          source: leadSource,
          properties: {
            'Lead Source': leadSource,
            'Lead Program': 'AI NAS',
            'AI NAS Product Interest': submission.productInterest,
            'AI NAS Primary Use': submission.useCase,
            'AI NAS Price Range': submission.priceRange,
          },
        }).catch((error) => console.warn('Nimo vote lead could not be routed to the AI NAS list.', error));
      }

      if (submission.email && shopifySyncForm && shopifyEmail) {
        shopifyEmail.value = submission.email;
        shopifySyncForm.submit();
      }
    }

    function clampIndex(index) {
      return (index + slides.length) % slides.length;
    }

    function activate(index, updateForm = true) {
      activeIndex = clampIndex(index);

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });

      const activeSlide = slides[activeIndex];
      const optionLabel = activeSlide.dataset.optionLabel;
      if (liveRegion) liveRegion.textContent = `Showing ${optionLabel || `concept ${activeIndex + 1}`}`;

      if (updateForm && formMount && optionLabel) {
        const matchingRadio = findMatchingRadio(optionLabel);
        if (matchingRadio && !matchingRadio.checked) matchingRadio.click();
      }
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => activate(Number(dot.dataset.index)));
    });
    previousButton?.addEventListener('click', () => activate(activeIndex - 1));
    nextButton?.addEventListener('click', () => activate(activeIndex + 1));

    section.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') activate(activeIndex - 1);
      if (event.key === 'ArrowRight') activate(activeIndex + 1);
    });

    let touchStartX = null;
    const gallery = section.querySelector('.nimo-nexus-vote__gallery');
    gallery?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    gallery?.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const delta = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
      if (Math.abs(delta) > 48) activate(activeIndex + (delta < 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });

    function bindKlaviyoForm() {
      const form = formMount?.querySelector('form');
      if (!form) return false;
      if (form !== boundForm) boundForm = form;

      enhanceKlaviyoForm(form);
      readSubmission(form);
      if (form.dataset.nimoSubmissionCapture !== 'true') {
        form.dataset.nimoSubmissionCapture = 'true';
        form.addEventListener('submit', () => readSubmission(form));
      }

      const radios = Array.from(form.querySelectorAll('input[type="radio"]'));
      if (!radios.length) return false;

      if (requestedIndex >= 0 && !campaignSelectionApplied) {
        const requestedSlide = slides[requestedIndex];
        const matchingRadio = findMatchingRadio(requestedSlide.dataset.optionLabel);
        activate(requestedIndex, false);
        if (!matchingRadio) return false;
        if (!matchingRadio.checked) matchingRadio.click();
        campaignSelectionApplied = matchingRadio.checked;
        if (!campaignSelectionApplied) return false;
        alignHashTarget();
        return true;
      }

      const selectedRadio = form.querySelector('input[type="radio"]:checked');
      if (selectedRadio) {
        const matchedIndex = slides.findIndex(
          (slide) => normalizeLabel(slide.dataset.optionLabel) === normalizeLabel(getRadioLabel(selectedRadio))
        );
        if (matchedIndex >= 0) activate(matchedIndex, false);
      }
      alignHashTarget();
      return true;
    }

    function alignHashTarget() {
      if (hashAligned || window.location.hash !== '#nexus-vote') return;
      hashAligned = true;
      window.requestAnimationFrame(() => section.scrollIntoView({ behavior: 'auto', block: 'start' }));
    }

    formMount?.addEventListener('change', (event) => {
      readSubmission();
      const radio = event.target.closest?.('input[type="radio"]');
      if (!radio || !radio.checked) return;
      const label = getRadioLabel(radio);
      const matchedIndex = slides.findIndex(
        (slide) => normalizeLabel(slide.dataset.optionLabel) === normalizeLabel(label)
      );
      if (matchedIndex >= 0) activate(matchedIndex, false);
    });

    formMount?.addEventListener('input', () => readSubmission());

    window.addEventListener('klaviyoForms', (event) => {
      if (event.detail?.type !== 'submit' || event.detail?.formId !== klaviyoFormId) return;
      handleSuccessfulSubmission();
    });

    if (formMount) {
      const observer = new MutationObserver(() => {
        bindKlaviyoForm();
      });
      observer.observe(formMount, { childList: true, subtree: true });
    }

    activate(requestedIndex >= 0 ? requestedIndex : 0, false);
    alignHashTarget();
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initVoteSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
